// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .portfolio-status-active {
  background-color: #A9DFBF;
  color: #495057;
  font-weight: normal;
}

 .portfolio-status-inactive {
  background-color: #F2F4F4;
  color: #495057;
  font-weight: normal;
}

 .portfolio-stage-H2L {
  background-color: #A69283;
  color: #ffffff;
  font-weight: normal;
}
 .portfolio-stage-LO {
  background-color: #75A3F4;
  color: #ffffff;
  font-weight: normal;
}
 .portfolio-stage-SP {
  background-color: #B2AACB;
  color: #ffffff;
  font-weight: normal;
}`, "",{"version":3,"sources":["webpack://./src/scene-d/HA/HAView/HAViewInformation/LocalComponents/LocalComponents.css"],"names":[],"mappings":"CAAC;EACC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;CAEC;EACC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;CAEC;EACC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;CACC;EACC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;CACC;EACC,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[" .portfolio-status-active {\n  background-color: #A9DFBF;\n  color: #495057;\n  font-weight: normal;\n}\n\n .portfolio-status-inactive {\n  background-color: #F2F4F4;\n  color: #495057;\n  font-weight: normal;\n}\n\n .portfolio-stage-H2L {\n  background-color: #A69283;\n  color: #ffffff;\n  font-weight: normal;\n}\n .portfolio-stage-LO {\n  background-color: #75A3F4;\n  color: #ffffff;\n  font-weight: normal;\n}\n .portfolio-stage-SP {\n  background-color: #B2AACB;\n  color: #ffffff;\n  font-weight: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
